import { createFileRoute } from "@tanstack/react-router";

import Chatbot from "../pages/Chatbot";
import { RequireAuth } from "../utils/RequireAuth";

// App.jsx folded the chatbot-access check into ProtectedRoute's
// isAuthenticated, which sent authenticated users without access to /login.
// RequireAuth require="chatbotAccess" sends them to "/" instead — an
// intentional fix of that /login bounce.
export const Route = createFileRoute("/_shell/chatbot")({
  component: ChatbotRoute,
});

function ChatbotRoute() {
  return (
    <RequireAuth require="chatbotAccess" page="chatbot">
      <Chatbot />
    </RequireAuth>
  );
}
